<!-- /用户管理/账号  -->
<template>
  <div class="changeColor containerLedger">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="新增用户" name="first">
        <div class="tabs_center"  v-if="activeName == 'first'">
          <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <!--用户角色-->
            <el-form-item label="用户角色" prop="userregion">
              <el-select v-model="form.userregion" placeholder="请选择用户角色" class="inp">
                <el-option v-for="item in region" :key="item.id" :value="item.id"
                           :label="item.role_name"></el-option>
              </el-select>
            </el-form-item>

            <!--机构/院校-->
            <el-form-item label="机构/院校" prop="organization_id">
              <el-autocomplete class="inline-input inp" v-model="state1" :fetch-suggestions="querySearch" disabled
                               placeholder="请选择机构、院校" @select="handleSelect" @blur="blur" style="min-width: 350px"></el-autocomplete>
            </el-form-item>

            <!--账号-->
<!--            <el-form-item label="账号" prop="account">-->
<!--              <el-input v-model="form.account" class="inp" placeholder="请输入账号" @keyup.native="form.account=form.account.replace(/[^\w_]/g,'')"></el-input>-->
<!--              <el-button type="warning" size="mini" style="margin-left: 20px" @click="randowClick(1)" round>随机生成账号</el-button>-->
<!--            </el-form-item>-->

            <!--手机号-->
            <el-form-item label="手机号" prop="phone" >
              <div style="display: flex;width: 350px;justify-content: space-between;align-items: center">
                <el-input v-model.trim="form.phone" class="inp" placeholder="请输入手机号" style="width: 250px"></el-input>
                <el-button  size="mini" style="height: 35px;" type="primary" plain @click="sendCode" :disabled="isSendBtn">{{isSendBtn?timeNum+'秒后重新发送':'发送验证码'}}</el-button>
              </div>

            </el-form-item>
<!--            验证码-->
            <el-form-item label="验证码" prop="phoneCode">
              <el-input v-model.trim="form.phoneCode" class="" placeholder="请输入验证码" style="width: 120px"></el-input>
            </el-form-item>
            <!--密码-->
            <el-form-item label="密码" prop="password">
              <el-input v-model.trim="form.password" class="inp" placeholder="请输入密码"></el-input>
              <el-button type="warning" size="mini" style="margin-left: 20px" @click="randowClick(2)" round>随机生成密码</el-button>
            </el-form-item>
            <!--姓名-->
            <el-form-item label="姓名" prop="uwsrname">
              <el-input v-model.trim="form.uwsrname" class="inp" placeholder="请输入姓名" maxlength="6"></el-input>
            </el-form-item>
            <!--性别-->
            <el-form-item label="性别" prop="sex">
              <el-select v-model="form.sex" placeholder="请选择性别" class="inp">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="0"></el-option>
                <el-option label="未知" value="2"></el-option>
              </el-select>
            </el-form-item>

            <!--学号-->
            <el-form-item label="学号">
              <el-input v-model.trim="form.student_no" class="inp" placeholder="请输入学号"></el-input>
            </el-form-item>




            <!--身份证号-->
<!--            <el-form-item label="身份证号">-->
<!--              <el-input v-model="form.idcard" class="inp" placeholder="请输入身份证号"></el-input>-->
<!--            </el-form-item>-->
            <!--            是否发送短信-->
            <el-form-item label="是否发送短信">

              <el-radio v-model="form.is_send" label="1" disabled>发送</el-radio>
              <el-radio v-model="form.is_send" label="2" disabled>不发送</el-radio>

            </el-form-item>

          </el-form>



          <el-row>
            <el-col>
<!--              <el-button @click="dialogVisible = true" type="primary">批量导入</el-button>-->
              <el-button type="primary" @click="SubmitBtn">提交</el-button>
            </el-col>
          </el-row>
          <!-- 批量导入  -->
        </div>
        <el-dialog title="批量导入" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
          <Imports :region="region" v-if="dialogVisible" @saveSuccess="dialogVisible = false"></Imports>
        </el-dialog>

        <div></div>
      </el-tab-pane>

      <el-tab-pane label="用户列表" name="second" class="user_list" >
        <div class="list" v-if="activeName == 'second'">
          <TeacherManagement />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  Submit,
  Remotesearch,
  MetaGettyperole,
} from "../../assets/js/network/network";
import TeacherManagement from '@/views/TeacherManagement';
import Imports from "./imports";
export default {
  name: "AccountManagement",
  components: {
    // UserList,
    TeacherManagement,
    Imports,
  },
  data() {
    return {
      timeNum:300,
      isSendBtn:false,
      userInfo:null,

      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
          // { pattern:/^0{0,1}(13[0-9]|15[7-9]|199|198|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }, // 这个只能验证手机号
          // { pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' },
        ],
        phoneCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码为6位纯数字', trigger: 'blur' },
        ],
        uwsrname: [
          { required: true, message: '请输入姓名', trigger: 'change' },
        ],
        userregion: [
          { required: true, message: '请选择用户角色', trigger: 'change' },
        ],
        organization_id: [
          { required: true, message: '请选择机构、院校', trigger: 'change' },
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' },
        ],
      },
      dialogVisible: false,
      //用户列表头部表单数据
      formlist: {
        region: [],
        name: "",
      },
      //院校下拉搜索模糊查询
      restaurants: [],
      state1: "",
      state2: "",
      //tabs切换状态
      activeName: "first",
      region: [{id:2,role_name:'教师'},{id:1,role_name:'学生'}],
      organizationName:'',
      //表单数据
      form: {
        phoneCode:'',
        //用户角色
        userregion: "",
        //机构/院校
        organization_id: "",
        //账号
        // account: "",
        //密码
        password: "",
        //姓名
        uwsrname: "",
        //性别
        sex: "",
        //学号
        student_no:'',
        //手机号
        phone:"",
        // idcard:'', //身份证号
        is_send:'2',
      },
    };
  },
  methods: {
    sendCode(){

      this.$refs.form.validateField('phone' , (errMsg) => {
        if (errMsg) {
          console.log('校验失败')
        }else{
          this.timeNum = 300
          this.$get(this.$api.userIsReg,{mobile:this.form.phone}).then(res=>{
            if(res.code == 0){
              this.$post(this.$api.regSendSms,{mobile:this.form.phone}).then(res=>{
                if(res.code == 0){
                  this.$message.success("验证码发送成功")
                  this.isSendBtn = true
                  let timer = setInterval(()=>{
                    this.timeNum --
                    if(this.timeNum == 0){
                      this.isSendBtn = false
                      clearInterval(timer)
                    }
                  },1000)
                }
              })
            }
          })

        }
      })
    },
    //teba切换
    handleClick(tab, event) {
      // console.log(tab, event);
      // console.log(this.activeName);

    },
    randowClick(v){
      var str = ['2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','J','K','M','N','P','Q','R','S','T','U','V','W','X','Y','Z'];
      var str1 = ['A','B','C','D','E','F','G','H','J','K','M','N','P','Q','R','S','T','U','V','W','X','Y','Z'];
      var str2 = ['2','3','4','5','6','7','8','9'];
      function generateMixed(n) {
        var res = "";
        for(var i = 0; i < n ; i ++) {
          var id = Math.ceil(Math.random()*30);
          res += str[id];
        }
        return res;
      }
      function generateMixed1(n) {
        var res = "";
        for(var i = 0; i < n ; i ++) {
          var id = Math.ceil(Math.random()*22);
          res += str1[id];
        }
        return res;
      }
      function generateMixed2(n) {
        var res = "";
        for(var i = 0; i < n ; i ++) {
          var id = Math.ceil(Math.random()*7);
          res += str2[id];
        }
        return res;
      }
      if(v == 1){
        //随机账号  账号开始必须是字母 中间含有数字 数字大概占四分之一
        this.form.account = generateMixed1(1)+generateMixed(7)
      }else {
        // 随机密码  密码中间2位是数字，两侧大写字母
        this.form.password = generateMixed1(2) +generateMixed2(2)+generateMixed1(2)
      }
    },
    //提交
    SubmitBtn() {
      // let str = "7e12e03df9cd01b6af36814cd4c2dff7";
      // let token = localStorage.getItem("tkoen");
      // token = str;

      var obj = {
        // token: token, //token
        organization_id: this.form.organization_id, //机构ID
        type_role: this.form.userregion, //角色
        is_send:this.form.is_send,      //是否 发送短信
        value_array: [{
          // account: this.form.account, //账号
          password: this.form.password?this.$md5(this.form.password):"", //密码
          realname: this.form.uwsrname, //昵称
          sex: this.form.sex, //性别
          student_no: this.form.student_no, //学号
          phone:this.form.phone, //手机号
          // idcard:this.form.idcard, //身份证号
        }, ],
      };
      // console.log(obj)
      this.$refs.form.validate((valid) => {
        if (valid) {
          // if (this.form.phone && !/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.form.phone)) {
          //   this.$message('手机号不合法')
          //   return
          // }
          // if(this.form.phone == this.form.account){
          //   this.$message.error('账号和手机号不能相同')
          //   return
          // }
          // if(this.form.idcard != ''){
          //   var regNum = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          //   if(!regNum.test(this.form.idcard))
          //   {
          //     this.$message({
          //       message: "身份证号不合法",
          //       type: "warning",
          //     });
          //     return
          //   }
          // }
          this.$get(this.$api.checkSmsCode,{mobile:this.form.phone,code:this.form.phoneCode}).then(res1=>{
            if(res1.code == 0){
              this.$post(this.$api.accountBatchimport,obj).then((res) => {

                let msg = []
                if(res.ret.length>0){
                  res.ret.map(item=>{
                    msg.push(item.msg)
                  })

                  this.$message.warning(msg.toString());

                }
                this.isSendBtn = false
                this.form.phoneCode = ''
              });
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //院校下拉搜索，模糊查询
    async querySearch(queryString, cb) {
      console.log(queryString);
      let data = {
        organization_name: queryString,
        paginate: 500,
      };
      await Remotesearch(data).then((res) => {
        // console.log(res.ret.data)
        this.restaurants = res.ret.data;
        this.restaurants.map((item) => {
          item.value = item.name;
        });
      });
      var restaurants = this.restaurants;
      var results = queryString ?
        restaurants.filter(this.createStateFilter(queryString)) :
        restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    createStateFilter(queryString) {
      return (state) => {
        return state.name.indexOf(queryString) != -1;
      };
    },

    handleSelect(item) {
      console.log(item);
      this.form.organization_id = item.id;
      this.organizationName = item.name
    },
    blur() {
      setTimeout(() => {
        console.log("失去焦点");
        if (this.state1 == this.organizationName) {
          this.form.organization_id = this.form.organization_id;
        } else {
          this.state1 = "";
          this.form.organization_id = "";
        }
      }, 100);
    },
    // getMetaGettyperole() {
    //   let data={};
    //   MetaGettyperole(data).then((res) => {
    //     this.region = res.ret;
    //   });
    // },
  },
  mounted() {
    this.userInfo =JSON.parse( localStorage.getItem('session'))
    if(this.userInfo){
      this.state1 = this.userInfo.organization_name
        this.form.organization_id = this.userInfo.organization_id
    }
    if(this.userInfo && (this.userInfo.organization_id=='497'||this.userInfo.organization_id=='12173'||this.userInfo.organization_id=='13344')){
      
      this.region.push({id:3,role_name:'管理员'})
    }
    // this.getMetaGettyperole(); //获取用户角色类型
  },
};
</script>

<style scoped>
.tabs_center {
  width: 85%;
  height: 750px;
  margin: 50px 0 0 140px;
}

.inp {
  width: 350px;
}

.user_list {
  width: 98%;
  /* height: 701px;
overflow: auto; */
  /* border: 1px solid red; */
}
>>>.el-form-item{
  margin-bottom: 15px;
}
</style>
